import React, { memo, useEffect, useRef } from 'react';
import { connect, useDispatch } from 'react-redux';
import {
  makeGetReceive3220,
  makeGetTradeHisPs,
} from '../../../../lib/selector';
import * as _ from 'lodash';
import { numberFormat, _processMapData10 } from '../../../../utils';
import {
  tradeHisPsAddRow,
  tradeHisPsRequest,
  tradeHisPsRequestSuccess,
} from '../../../../containers/banggia/actions';

// Hook
function usePrevious(value) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  const ref = useRef();

  // Store current value in ref
  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  // Return previous value (happens before update in useEffect above)
  return ref.current;
}

function TblTradeHis(props) {
  const dispatch = useDispatch();
  const prevReceive3220 = usePrevious(props.receive3220);

  useEffect(() => {
    if (props.sym) {
      // get ndata snapshot
      dispatch(tradeHisPsRequest(props.sym));
    }

    return () => {
      dispatch(tradeHisPsRequestSuccess([]));
    };
  }, [props.sym]);

  useEffect(() => {
    if (
      props.receive3220 &&
      !_.isEqual(props.receive3220, prevReceive3220) &&
      props.receive3220.sym === props.expandSym &&
      props.receive3220.sID &&
      props.receive3220.time !== 'null'
    ) {
      console.log(props.receive3220);
      // dispatch add row
      dispatch(tradeHisPsAddRow(props.receive3220));
    }
  }, [props.receive3220]);

  //   console.log(props.tradeHisPs)

  return (
    <table className="table table-bordered w-100">
      <thead>
        <tr>
          <th>Thời gian</th>
          <th>KL</th>
          <th>Giá</th>
          <th>+/-</th>
        </tr>
      </thead>
      <tbody>
        {props.tradeHisPs &&
          props.tradeHisPs.map((item, idx) => (
            <tr key={idx}>
              <td className="text-center">{item.time}</td>
              <td className="text-right">{numberFormat(item.lastVol)}</td>
              <td className={'text-right ' + item.cl}>
                {numberFormat(item.lastPrice, 1)}
              </td>
              <td className={'text-right ' + item.cl}>{item.change}</td>
            </tr>
          ))}
      </tbody>
    </table>
  );
}

const makeMapStateToProps = () => {
  const getTradeHisPs = makeGetTradeHisPs();
  const getReceive3220 = makeGetReceive3220();

  const mapStateToProps = (state) => {
    return {
      tradeHisPs: getTradeHisPs(state),
      receive3220: getReceive3220(state),
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(memo(TblTradeHis));
